<script lang="ts" setup>
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'photoswipe/style.css'

const props = defineProps<{
  data: {
    id: 'string'
    images: {
      directus_files_id: DirectusFile
    }[]
  }
}>()

const images = computed(() => {
  return props.data.images.map((files) => {
    return {
      ...files.directus_files_id,
    }
  }).filter((file) => {
    return file.type.includes('image')
  })
})

function spanCalc(index: number) {
  const number = index % 6
  switch (number) {
    case 0:
      return 'md:col-span-3'
    case 1:
      return ''
    case 2:
      return 'md:col-span-2'
    case 3:
      return 'md:col-span-3'
    case 4:
      return 'md:col-span-2'
    case 5:
      return ''
  }
}

// lightbox gallery

const lightBox = ref<PhotoSwipeLightbox>()

const config = useRuntimeConfig()
const assetRoot = `${config.public.directus.url}/assets/`
const gallery = ref<HTMLDivElement>()

onMounted(() => {
  lightBox.value = new PhotoSwipeLightbox({
    gallery: gallery.value,
    children: 'a',
    pswpModule: () => import('photoswipe'),
    preloaderDelay: 0,
  })
  lightBox.value.init()
})

onUnmounted(() => {
  if (lightBox.value) {
    lightBox.value.destroy()
    lightBox.value = undefined
  }
})
</script>

<template>
  <BlockBase>
    <Container>
      <div ref="gallery" class="grid grid-cols-1 gap-2rem py-12rem md:grid-cols-3">
        <a
          v-for="image, index in images"
          :key="image.id"
          :href="assetRoot + image.id"
          class="relative block h-50rem transition hover:shadow-starline"
          :class="spanCalc(index)"
          :data-pswp-width="image.width"
          :data-pswp-height="image.height"
          data-cropped="true"
          target="_blank"
          rel="noreferrer"
        >
          <NuxtImg
            loading="lazy"
            provider="directus" height="500" :src="image.id" :alt="image.description ?? image.title ?? ''"
            class="h-full w-full object-cover"
          />
        </a>
      </div>
    </Container>
  </BlockBase>
</template>

<style></style>
